import { createEvent, createStore, sample } from "effector";
import { trackAiAssistantModelSelectClick, trackAiAssistantModelSelectCloseClick } from "@features/shared/events";
import { routePathNameChanged } from "@features/app/model";

export const $selectorShown = createStore(false)
export const toggleSelector = createEvent<boolean>()
type ModelInfo = {
    model: string
    provider: string,
    icon: string,
    name: string,
}
export const $modelInfo = createStore<ModelInfo>({
    model: "gpt-5-nano",
    provider: "openai",
    icon: "openai",
    name: "ChatGPT"
})

export const setModelInfo = createEvent<ModelInfo>()

sample({
    clock: toggleSelector,
    target: $selectorShown
})

sample({
    clock: setModelInfo,
    target: $modelInfo
})
export const $firstAssistantAnswerCompleted = createStore(false)
export const setFirstAssistantAnswerCompleted = createEvent<boolean>()

sample({
    clock: setFirstAssistantAnswerCompleted,
    target: $firstAssistantAnswerCompleted
})

sample({
    clock: routePathNameChanged,
    fn: () => false,
    target: setFirstAssistantAnswerCompleted
})
export const modelSelectOpened = createEvent();
export const modelSelectClosed = createEvent();

modelSelectOpened.watch(() => trackAiAssistantModelSelectClick());
modelSelectClosed.watch(() => trackAiAssistantModelSelectCloseClick());

sample({
    clock: toggleSelector,
    filter: (open) => open === true,
    target: modelSelectOpened
});

sample({
    clock: toggleSelector,
    filter: (open) => open === false,
    target: modelSelectClosed
});
